import Immutable from 'immutable';
import { createMigration } from './utils';

export const migrationTo9_153 = createMigration({
    migrateVideo(video) {
        const oldSceneGroups = video.get('sceneGroups');
        let newSceneGroups = Immutable.Map();

        oldSceneGroups.forEach((oldSceneGroup: Immutable.Map<string, any>) => {
            oldSceneGroup.get('sceneIds').forEach((sceneId: string) => {
                newSceneGroups = newSceneGroups.set(sceneId, oldSceneGroup.get('id'));
            });
        });

        return video.set('sceneGroups', newSceneGroups);
    },
});
